import styles from "./DepartmentPopover.module.css";

export function DepartmentPopover({ statuses, onStatusSelect }) {
  return (
    <ul className={styles.dropdownList}>
      {statuses.map(({ status }) => (
        <li
          key={status}
          onClick={(e) => {
            e.stopPropagation();
            onStatusSelect(status);
          }}
          className={styles.dropdownLi}
        >
          <div className={styles.statusItemContainer}>
            {status}
          </div>
        </li>
      ))}
    </ul>
  );
}
